<script setup lang="ts">
import useContextMenuPosition, { ContextMenuPosition } from 'frontcore/views/context-menu/useContextMenuPosition'
import { ref, toRefs } from 'vue'

type Props = {
  anchor: HTMLElement | null
  positions: ContextMenuPosition[]
  withAnchorWidth?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  withAnchorWidth: false,
})
const { anchor, positions, withAnchorWidth } = toRefs(props)

const contextMenu = ref<HTMLElement | null>(null)
const positionStyle = useContextMenuPosition(anchor, contextMenu, positions, withAnchorWidth)
</script>

<template>
  <div
    ref="contextMenu"
    class="core-context-menu"
    :style="positionStyle">
    <slot />
  </div>
</template>
